// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-wrapper .search-global-cont {
  color: #000;
  font-weight: 400;
  font-size: 16px;
}

.dash-nav {
  font-size: 16px;
  font-weight: 500;
}
.dash-nav .active {
  font-weight: 700;
  color: #D0566E;
  border-bottom: 2px solid #D0566E;
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Dashboard.scss"],"names":[],"mappings":"AACI;EACI,WAAA;EACA,gBAAA;EACA,eAAA;AAAR;;AAIA;EACI,eAAA;EACA,gBAAA;AADJ;AAGI;EACI,gBAAA;EACA,cAAA;EACA,gCAAA;AADR","sourcesContent":[".dashboard-wrapper{\n    .search-global-cont{\n        color: #000;\n        font-weight: 400;\n        font-size: 16px;\n    }\n}\n\n.dash-nav {\n    font-size: 16px;\n    font-weight: 500;\n\n    .active {\n        font-weight: 700;\n        color: #D0566E;\n        border-bottom: 2px solid  #D0566E;\n    }\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
